import { render, staticRenderFns } from "./budget.vue?vue&type=template&id=5e184622"
import script from "./budget.ts?vue&type=script&lang=js&external"
export * from "./budget.ts?vue&type=script&lang=js&external"
import style0 from "./budget.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports